/* @flow */
import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { List } from 'material-ui/List';

import type { TutorBooked_tutor } from './__generated__/TutorBooked_tutor.graphql';
import TutorJobBooked from './job/TutorJobBooked';
import TutorJobEmptyItem from './job/TutorJobEmptyItem';

type Props = {
  tutor: TutorBooked_tutor,
};

const TutorBooked = ({ tutor: { jobs } }: Props) =>
  jobs && jobs.edges.length > 0 ? (
    <div>
      <List>
        {jobs.edges.map(
          edge =>
            edge &&
            edge.node && <TutorJobBooked key={edge.node.id} job={edge.node} />
        )}
      </List>
    </div>
  ) : (
    <TutorJobEmptyItem />
  );

export default createFragmentContainer(TutorBooked, {
  tutor: graphql`
    fragment TutorBooked_tutor on Tutor {
      jobs(first: 10, status: [Started]) {
        edges {
          node {
            id
            ...TutorJobBooked_job
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  `,
});



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/TutorBooked.js